module.exports = __webpack_public_path__ + "static/media/playButton2.edd6c947.png";